


















































































































import {
  BSidebar,
  BSpinner,
  BForm,
  BButton,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormFile,
  VBTooltip
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { DocumentBeneficiaire, UpdateDocumentBeneficiaireModel } from '@/api/models/documentsBeneficiaire/documentBeneficiaire';
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";

@Component({
  components: {
    BSidebar,
    BCol,
    BSpinner,
    BButton,
    BFormInput,
    BForm,
    BFormGroup,
    BFormFile,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
})
export default class UpdateDocumentBeneficiaire extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdateDocumentBeneficiaireSidebarActive!: boolean;
  @Prop({ required: true }) documentBeneficiaireId!: string;

  loading = false;
  required = required;
  loadingDocumentBeneficiaire = false;
  isAddFileEnabled = false;

  listTypeContrat = [];
  totalCountTypeContrat = 0;

  documentBeneficiaire: UpdateDocumentBeneficiaireModel = {};

 async created() {
  console.log(this.documentBeneficiaireId)
    await this.$http.myressif.partenairesFASTT
      .getDocumentBeneficiaireById(
        this.$route.params.id,
        this.documentBeneficiaireId
      )
      .then((res: DocumentBeneficiaire) => {
        this.documentBeneficiaire = res;
        this.loadingDocumentBeneficiaire = true;
      });

    await this.getTypeContrat();
  }

  resetForm() {
    this.documentBeneficiaire = {};
  }

  async getTypeContrat() {
    await this.$http.myressif.parametres
      .getByNom("type_document_beneficiaire_partenaire_fastt")
      .then((res: any) => {
        this.listTypeContrat = res ? JSON.parse(res.valeur) : [];
      }),
      (error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      };
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.partenairesFASTT
      .updateDocumentBeneficiairePartenaireFASTT(
        this.$route.params.id,
        this.documentBeneficiaire.id,
        this.documentBeneficiaire
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification du document bénéficiaire",
            text: "Document bénéficiaire modifié avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-documents-beneficiaire");
        this.$emit("update:is-update-document-beneficiaire-sidebar-active", false);
        this.loading = false;
        this.isAddFileEnabled = false;
      });
  }
}
